import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import GetLoans from "./GetLoans";
import GetAdvancedSalary from "./GetAdvancedSalary";
import GetLoansAndAdvancedSalary from "./GetLoansAndAdvancedSalary";

const PayrollManagement = (props) => {
  const [activeTab, setActiveTab] = useState("loans"); // Loans actif par défaut

  return (
    <div className="container-fluid px-3 py-4">
      <h5 className="mb-3">{props.t("payroll_management")}</h5>

      {/* Onglets */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "loans" ? "active" : ""}`}
            onClick={() => setActiveTab("loans")}
          >
            {props.t("loan_management")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "advancedSalary" ? "active" : ""}`}
            onClick={() => setActiveTab("advancedSalary")}
          >
            {props.t("advanced_salary")}
          </button>
        </li>
         <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "loansAndadvancedSalary" ? "active" : ""}`}
            onClick={() => setActiveTab("loansAndadvancedSalary")}
          >
            {props.t("loans_and_advanced_salary")}
          </button>
        </li>
      </ul>

      {/* Contenu */}
      <div>
        {activeTab === "loans" && <GetLoans />}
        {activeTab === "advancedSalary" && <GetAdvancedSalary />}
        {activeTab === "loansAndadvancedSalary" && <GetLoansAndAdvancedSalary />}
      </div>
    </div>
  );
};

export default withTranslation()(PayrollManagement);
